var $aed0f1dbc6ac496f$exports = {};
let $aed0f1dbc6ac496f$var$tabHeader = document.getElementsByClassName("tab-header")[0];
let $aed0f1dbc6ac496f$var$tabIndicator = document.getElementsByClassName("tab-indicator")[0];
let $aed0f1dbc6ac496f$var$tabBody = document.getElementsByClassName("tab-body")[0];
let $aed0f1dbc6ac496f$var$tabsPane = $aed0f1dbc6ac496f$var$tabHeader.getElementsByTagName("div");
for(let i = 0; i < $aed0f1dbc6ac496f$var$tabsPane.length; i++)$aed0f1dbc6ac496f$var$tabsPane[i].addEventListener("click", function() {
    $aed0f1dbc6ac496f$var$tabHeader.getElementsByClassName("active")[0].classList.remove("active");
    $aed0f1dbc6ac496f$var$tabsPane[i].classList.add("active");
    $aed0f1dbc6ac496f$var$tabBody.getElementsByClassName("active")[0].classList.remove("active");
    $aed0f1dbc6ac496f$var$tabBody.getElementsByClassName("tab")[i].classList.add("active");
    $aed0f1dbc6ac496f$var$tabIndicator.style.left = `calc(calc(100% / 4) * ${i})`;
});
function $aed0f1dbc6ac496f$var$portataRow(title) {
    return `
    <h2 style="margin-top: 2.5rem;">${title}</h2>`;
}
function $aed0f1dbc6ac496f$var$piattoRow(name, description, price) {
    return `<div class="row" style="border-bottom: 1px solid #CCC;">
        <div class="col-xs-10 col-sm-10 col-md-10 col-lg-10" style="padding-left: 0px;">
            ${name}<br>
            <i>${description}</i>
        </div>
        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2" style="padding-left: 0px; white-space: nowrap;">${price != 0 ? `&euro; ${price.toFixed(2).replace(".", ",")}` : ""}</div>

   </div>`;
}
document.addEventListener("DOMContentLoaded", ()=>{
    var _document_querySelector;
    // Determina la lingua dall'URL
    const lang = window.location.pathname.includes("/en/") ? "en" : "it";
    const apiUrl = "https://adm.osteriaalbraciere.it/api/menuallacarta/published/";
    const modalContainer = document.createElement("div");
    modalContainer.id = "calendar-modal";
    modalContainer.style.display = "none";
    modalContainer.innerHTML = `
    <div class="modal-container">
        <div class="modal-header">
            <span class="close-btn">&times;</span>
            ${lang === "it" ? "Calendario dei men\xf9" : "Menu calendar"}
        </div>
        <div class="modal-content">
            <div id="calendar-container"></div>
            <div id="menu-details" style="margin-top: 1rem;"></div>
        </div>
    </div>
`;
    document.body.appendChild(modalContainer);
    const calendarContainer = document.getElementById("calendar-container");
    const menuDetailsContainer = document.getElementById("menu-details");
    const modal = document.getElementById("calendar-modal");
    const closeModal = modal.querySelector(".close-btn");
    let currentYear = new Date().getFullYear();
    let currentMonth = new Date().getMonth() + 1; // Mesi da 1 a 12
    // Funzione per ottenere i dati dal JSON
    async function fetchMenuData(year, month) {
        try {
            const response = await fetch(`${apiUrl}${year}/${month}`);
            if (!response.ok) throw new Error("Errore nel caricamento dei dati");
            const data = await response.json();
            return data || [];
        } catch (error) {
            console.error(error);
            return [];
        }
    }
    // Funzione per caricare il primo giorno disponibile
    async function loadFirstAvailableDay() {
        const menuData = await fetchMenuData(currentYear, currentMonth);
        if (menuData.length > 0) {
            const firstMenu = menuData[0]; // Prendi il primo elemento del JSON
            renderMenuDetailsWithRows(firstMenu); // Mostra i dettagli del primo giorno
        } else console.warn("Nessun menu disponibile per il mese corrente.");
    }
    async function renderCalendar(year, month) {
        var // Eventi per i pulsanti di navigazione
        _document_getElementById, _document_getElementById1;
        const daysInMonth = new Date(year, month, 0).getDate();
        const firstDay = (new Date(year, month - 1, 1).getDay() + 6) % 7; // Calcola il primo giorno (0 = lunedì)
        const menuData = await fetchMenuData(year, month);
        // Estrai i giorni dal JSON
        const highlightedDays = menuData.map((menu)=>new Date(menu.menu_date).getDate());
        // Pulizia del contenitore
        calendarContainer.innerHTML = "";
        // Header del calendario
        const header = document.createElement("div");
        header.className = "calendar-header";
        header.innerHTML = `
        <button id="prev-month">&lt;</button>
        <span>${year}-${String(month).padStart(2, "0")}</span>
        <button id="next-month">&gt;</button>
    `;
        calendarContainer.appendChild(header);
        // Corpo del calendario
        const calendarGrid = document.createElement("div");
        calendarGrid.className = "calendar-grid";
        calendarGrid.style.display = "grid";
        calendarGrid.style.gridTemplateColumns = "repeat(7, 1fr)";
        calendarGrid.style.gap = "5px";
        // Giorni della settimana (inizia con lunedì)
        const daysOfWeek = lang === "it" ? [
            "Lun",
            "Mar",
            "Mer",
            "Gio",
            "Ven",
            "Sab",
            "Dom"
        ] : [
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat",
            "Sun"
        ];
        daysOfWeek.forEach((day)=>{
            const dayElement = document.createElement("div");
            dayElement.className = "calendar-day-header";
            dayElement.textContent = day;
            calendarGrid.appendChild(dayElement);
        });
        // Giorni vuoti prima del primo giorno del mese
        for(let i = 0; i < firstDay; i++){
            const emptyCell = document.createElement("div");
            emptyCell.className = "calendar-empty";
            calendarGrid.appendChild(emptyCell);
        }
        // Giorni del mese
        for(let day = 1; day <= daysInMonth; day++){
            const dayElement = document.createElement("div");
            dayElement.className = "calendar-day";
            dayElement.textContent = day.toString();
            // Evidenzia i giorni presenti nel JSON
            if (menuData.some((menu)=>{
                const menuDate = new Date(menu.menu_date);
                return menuDate.getDate() === day && menuDate.getMonth() + 1 === month && menuDate.getFullYear() === year;
            })) {
                dayElement.style.backgroundColor = "#ffcc00";
                dayElement.style.color = "#000";
                dayElement.style.fontWeight = "bold";
                dayElement.style.cursor = "pointer";
                // Aggiungi evento per mostrare i dettagli del menu
                dayElement.addEventListener("click", ()=>{
                    const menuForDay = menuData.find((menu)=>{
                        const menuDate = new Date(menu.menu_date);
                        return menuDate.getDate() === day && menuDate.getMonth() + 1 === month && menuDate.getFullYear() === year;
                    });
                    renderMenuDetailsWithRows(menuForDay);
                });
            }
            calendarGrid.appendChild(dayElement);
        }
        calendarContainer.appendChild(calendarGrid);
        (_document_getElementById = document.getElementById("prev-month")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.addEventListener("click", ()=>{
            currentMonth--;
            if (currentMonth < 1) {
                currentMonth = 12;
                currentYear--;
            }
            renderCalendar(currentYear, currentMonth);
        });
        (_document_getElementById1 = document.getElementById("next-month")) === null || _document_getElementById1 === void 0 ? void 0 : _document_getElementById1.addEventListener("click", ()=>{
            currentMonth++;
            if (currentMonth > 12) {
                currentMonth = 1;
                currentYear++;
            }
            renderCalendar(currentYear, currentMonth);
        });
    }
    // Funzione per mostrare i dettagli del menu
    function renderMenuDetails(menu) {
        if (!menu) {
            menuDetailsContainer.innerHTML = "<p>Nessun menu disponibile per questa data.</p>";
            return;
        }
        const portateHtml = menu.portate.map((portata)=>{
            const piattiHtml = portata.piatti.map((piatto)=>`
                <div>
                    <h4>${piatto.langname[lang].titolo}</h4>
                    <p>${piatto.langname[lang].descrizione || ""}</p>
                    <p>Prezzo: \u{20AC}${piatto.price}</p>
                </div>
            `).join("");
            return `
                <div>
                    <h3>${portata.langname[lang]}</h3>
                    ${piattiHtml}
                </div>
            `;
        }).join("");
        menuDetailsContainer.innerHTML = portateHtml;
    }
    function renderMenuDetailsWithRows(menu) {
        const menuPerDataElement = document.querySelector(".menuPerData");
        if (!menuPerDataElement) {
            console.error("Elemento con classe 'menuPerData' non trovato.");
            return;
        }
        if (!menu) {
            menuPerDataElement.innerHTML = "<p>Nessun menu disponibile per questa data.</p>";
            return;
        }
        // Formatta la data del menu
        const menuDate = new Date(menu.menu_date);
        const options = {
            weekday: "long",
            day: "numeric",
            month: "long"
        };
        let formattedDate = menuDate.toLocaleDateString(lang === "it" ? "it-IT" : "en-US", options);
        // Capitalizza la prima lettera del mese
        formattedDate = formattedDate.split(" ").map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
        // Genera le righe per ogni portata e piatto
        const portateHtml = menu.portate.map((portata)=>{
            const piattiHtml = portata.piatti.map((piatto)=>$aed0f1dbc6ac496f$var$piattoRow(piatto.langname[lang].titolo, piatto.langname[lang].descrizione || "", parseFloat(piatto.price))).join("");
            return $aed0f1dbc6ac496f$var$portataRow(portata.langname[lang]) + piattiHtml;
        }).join("");
        // Aggiorna il contenuto dell'elemento con la classe "menuPerData"
        menuPerDataElement.innerHTML = `
        <br><h2>Men\xf9 ${lang === "it" ? "di" : "of"} ${formattedDate}</h2>
        ${portateHtml}
    `;
        // Chiudi la modal del calendario
        const modal = document.getElementById("calendar-modal");
        modal.style.display = "none";
    }
    // Funzione per aprire il modal
    function openModal() {
        modal.style.display = "block";
        renderCalendar(currentYear, currentMonth);
    }
    // Funzione per chiudere il modal
    closeModal.addEventListener("click", ()=>{
        modal.style.display = "none";
    });
    // Aggiungi evento per aprire il modal
    const openCalendarButton = document.createElement("button");
    openCalendarButton.className = "open-calendar-btn";
    openCalendarButton.textContent = lang === "it" ? "Apri Calendario" : "Open Calendar";
    openCalendarButton.addEventListener("click", openModal);
    (_document_querySelector = document.querySelector(".discoverMenus")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.appendChild(openCalendarButton);
    // Carica il primo giorno disponibile al caricamento della pagina
    loadFirstAvailableDay();
});


//# sourceMappingURL=menu.06e74077.js.map
